exports.KEYS = {
  // API: `http://4bba-103-150-209-78.ngrok.io`,
  API: process.env.REACT_APP_API_URL || "https://spoflex-825672385627.herokuapp.com",
  // API: "http://localhost:5001",
  // API: "https://8bfc-2407-d000-b-3c8f-40fd-e991-2196-45a1.ngrok-free.app",
  FRONTEND: "http://localhost:3000"
};
